export const exerciseApi = {
 createExercisesTable: (): string =>
  `/api/portal/staff/medical/doctor/exercises/exercise-table`,
 fetchExercisesTable: (id: string): string =>
  `/api/portal/staff/patients/${id}/exercise-table`,
 fetchExercisesTableHistory: (id: string): string =>
  `/api/portal/staff/patients/${id}/exercise-table/history`,
 exportExercisesTable: (id: string): string =>
  `/api/portal/staff/exercises/exercise-table/${id}/export`,
 exportExercisesTableHistory: (id: string): string =>
  `/api/portal/staff/patients/${id}/exercise-table/history/export`,
 updateExercisesTable: (id: string): string =>
  `/api/portal/staff/medical/doctor/exercises/exercise-table/${id}`,
 deleteExercisesTable: (id: string): string =>
  `/api/portal/staff/medical/doctor/exercises/exercise-table/${id}`,
};
